import React from 'react';
import { connect } from 'react-redux';
import { toggleMobileNavVisibility } from '../../reducers/Layout';
import { Navbar } from 'react-bootstrap';
//import headerImage from 'assets/images/logo.png';

const Header = ({
  showMobileMenu,
  toggleMobileNavVisibility
}) => (
    <Navbar fluid={true} className="rounded-0" style={{ backgroundColor: '#0A2E7C', borderRadius: '0px' }}>
      
      <Navbar.Brand href="#" style={{ color: '#FFF' }}>Amrut Cup - {new Date().getFullYear()}</Navbar.Brand>
      <Navbar.Header>
        <button type="button" className="navbar-toggle" data-toggle="collapse" onClick={toggleMobileNavVisibility}>
          <span className="sr-only">Toggle navigation</span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
          <span className="icon-bar"></span>
        </button>
      </Navbar.Header>
    </Navbar>
  );

const mapDispatchToProp = dispatch => ({
  toggleMobileNavVisibility: () => dispatch(toggleMobileNavVisibility())
});

export default connect(null, mapDispatchToProp)(Header);


// WEBPACK FOOTER //
// ./src/pages/Main/Header.js